import { cn } from '@/lib/utils'

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
  label?: string
}

const sizeMap = {
  sm: 'w-4 h-4 border-[1.5px]',
  md: 'w-6 h-6 border-2',
  lg: 'w-8 h-8 border-[2.5px]',
} as const

export function Spinner({ size = 'md', className, label = 'Caricamento...' }: SpinnerProps) {
  return (
    <div
      role="status"
      aria-label={label}
      className={cn('inline-flex items-center justify-center', className)}
    >
      <div
        className={cn(
          'rounded-full border-slate-200 border-t-primary-500 animate-spin',
          sizeMap[size]
        )}
      />
      <span className="sr-only">{label}</span>
    </div>
  )
}

export function PageSpinner({ label }: { label?: string }) {
  return (
    <div className="flex items-center justify-center min-h-64 w-full">
      <div className="flex flex-col items-center gap-3">
        <Spinner size="lg" label={label ?? 'Caricamento...'} />
        {label && (
          <p className="text-sm text-slate-500">{label}</p>
        )}
      </div>
    </div>
  )
}
